module.exports = __webpack_public_path__ + "src/images/products/prep/24_Aiden Slim Rapid Movement Chino.png";